export const SYSTEM_MESSAGE_REQUEST = 'SYSTEM_MESSAGE_REQUEST';
export const SYSTEM_MESSAGE_SUCCESS = 'SYSTEM_MESSAGE_SUCCESS';
export const SYSTEM_MESSAGE_FAILURE = 'SYSTEM_MESSAGE_FAILURE';

export const DISCARD_SYSTEM_MESSAGE_REQUEST = 'DISCARD_SYSTEM_MESSAGE_REQUEST';
export const DISCARD_SYSTEM_MESSAGE_SUCCESS = 'DISCARD_SYSTEM_MESSAGE_SUCCESS';
export const DISCARD_SYSTEM_MESSAGE_FAILURE = 'DISCARD_SYSTEM_MESSAGE_FAILURE';

export const UNLOCK_SYSTEM_MESSAGE_REQUEST = 'UNLOCK_SYSTEM_MESSAGE_REQUEST';
export const UNLOCK_SYSTEM_MESSAGE_SUCCESS = 'UNLOCK_SYSTEM_MESSAGE_SUCCESS';
export const UNLOCK_SYSTEM_MESSAGE_FAILURE = 'UNLOCK_SYSTEM_MESSAGE_FAILURE';

export const TOGGLE_MESSAGE_CENTER = 'TOGGLE_MESSAGE_CENTER';
